/* ============================================================
   PDF Brochure Downloader — JavaScript
   Handles: language select, modal open/close, form validation,
            Shopify contact form submit, PDF download.
   Features:
     - Forces actual file download (not open-in-tab)
     - Remembers user details in localStorage — no re-fill needed
       for subsequent language downloads
   ============================================================ */

(function () {
  'use strict';

  var STORAGE_KEY = 'pdf_brochure_lead';

  /* ── Helpers ── */
  function $(id) { return document.getElementById(id); }

  function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val.trim());
  }

  function isValidPhone(val) {
    var digits = val.replace(/\D/g, '');
    return /^[\d\s\+\-\(\)]{7,20}$/.test(val.trim()) && digits.length >= 7;
  }

  function setError(inputEl, errorEl, show) {
    if (show) {
      inputEl.classList.add('has-error');
      errorEl.hidden = false;
    } else {
      inputEl.classList.remove('has-error');
      errorEl.hidden = true;
    }
  }

  /* ── LocalStorage helpers ── */
  function getSavedLead() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function saveLead(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  /* ── Toast notification ── */
  function showToast(message, duration) {
    var existing = document.getElementById('pdf-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'pdf-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.style.cssText = [
      'position:fixed',
      'bottom:24px',
      'left:50%',
      'transform:translateX(-50%) translateY(12px)',
      'background:#222',
      'color:#fff',
      'padding:12px 22px',
      'border-radius:8px',
      'font-size:0.92em',
      'font-family:inherit',
      'box-shadow:0 4px 20px rgba(0,0,0,0.25)',
      'z-index:2147483646',
      'opacity:0',
      'transition:opacity 0.25s,transform 0.25s',
      'display:flex',
      'align-items:center',
      'gap:10px',
      'white-space:nowrap',
      'pointer-events:none'
    ].join(';');

    toast.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>' + message;

    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    });

    setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(12px)';
      setTimeout(function () { if (toast.parentNode) toast.remove(); }, 300);
    }, duration || 3000);
  }

  /* ── PDF download helper ──
     Fetches the file as a blob so the browser always saves it to disk
     (avoids "open in background tab" or inline-viewer behaviour).
     Falls back to a direct anchor click if fetch/CORS fails.         */
  function triggerDownload(url, lang) {
    var filename = 'brochure' + (lang ? '-' + lang : '') + '.pdf';

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('fetch failed');
        return res.blob();
      })
      .then(function (blob) {
        var blobUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href     = blobUrl;
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function () { URL.revokeObjectURL(blobUrl); }, 30000);
      })
      .catch(function () {
        /* CORS or network fallback — create direct download anchor */
        var a = document.createElement('a');
        a.href     = url;
        a.download = filename;
        a.target   = '_blank';
        a.rel      = 'noopener';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
  }

  /* ── Init per product ── */
  function initBrochure(productId) {
    var pid = productId;

    var selectEl      = $('pdf-lang-'         + pid);
    var downloadBtn   = $('pdf-download-btn-' + pid);
    var overlay       = $('pdf-overlay-'      + pid);
    var modal         = $('pdf-modal-'        + pid);
    var closeBtn      = $('pdf-modal-close-'  + pid);
    var langDisplay   = $('pdf-lang-display-' + pid);
    var langValInput  = $('pdf-lang-val-'     + pid);
    var urlValInput   = $('pdf-url-val-'      + pid);
    var formWrap      = $('pdf-form-wrap-'    + pid);
    var successDiv    = $('pdf-success-'      + pid);
    var closeSuccess  = $('pdf-close-success-'+ pid);
    var submitBtn     = $('pdf-submit-'       + pid);

    /* Tracks the currently selected PDF URL and language across the modal lifecycle.
       Cannot rely on the hidden form inputs because form.reset() clears them. */
    var currentPdfUrl = '';
    var currentLang   = '';

    var nameInput     = $('pdf-name-'    + pid);
    var phoneInput    = $('pdf-phone-'   + pid);
    var emailInput    = $('pdf-email-'   + pid);

    var nameErr       = $('pdf-name-err-'  + pid);
    var phoneErr      = $('pdf-phone-err-' + pid);
    var emailErr      = $('pdf-email-err-' + pid);

    if (!selectEl || !downloadBtn || !overlay) return;

    /* -- Enable Download button only when language is chosen -- */
    selectEl.addEventListener('change', function () {
      downloadBtn.disabled = !this.value;
    });

    /* -- Download button click -- */
    downloadBtn.addEventListener('click', function () {
      var opt    = selectEl.options[selectEl.selectedIndex];
      var pdfUrl = selectEl.value;
      var lang   = opt.getAttribute('data-lang') || '';

      currentPdfUrl           = pdfUrl;
      currentLang             = lang;

      langDisplay.textContent = lang;
      langValInput.value      = lang;
      urlValInput.value       = pdfUrl;

      var saved = getSavedLead();
      if (saved) {
        /* User already submitted details — download immediately, skip form */
        triggerDownload(pdfUrl, lang);
        showToast('Downloading ' + (lang || 'brochure') + ' PDF…');
        submitLeadSilently(saved, lang, pdfUrl);
      } else {
        openModal();
      }
    });

    /* -- Open / Close helpers -- */
    function openModal() {
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      formWrap.hidden   = false;
      successDiv.hidden = true;
      resetForm();

      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
      });

      setTimeout(function () { modal.focus(); }, 100);
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      setTimeout(function () {
        overlay.hidden = true;
        document.body.style.overflow = '';
      }, 280);
    }

    function resetForm() {
      var form = modal.querySelector('form');
      if (form) form.reset();
      [nameInput, phoneInput, emailInput].forEach(function (el) {
        el && el.classList.remove('has-error');
      });
      [nameErr, phoneErr, emailErr].forEach(function (el) {
        if (el) el.hidden = true;
      });
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg> Submit &amp; Download';
      }
    }

    /* -- Close triggers -- */
    closeBtn.addEventListener('click', closeModal);

    if (closeSuccess) {
      closeSuccess.addEventListener('click', closeModal);
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeModal();
    });

    /* -- Form Submission -- */
    var form = modal.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var valid = true;

      var nameVal = nameInput ? nameInput.value.trim() : '';
      if (!nameVal) {
        setError(nameInput, nameErr, true);
        valid = false;
      } else {
        setError(nameInput, nameErr, false);
      }

      var phoneVal = phoneInput ? phoneInput.value.trim() : '';
      if (!phoneVal || !isValidPhone(phoneVal)) {
        setError(phoneInput, phoneErr, true);
        valid = false;
      } else {
        setError(phoneInput, phoneErr, false);
      }

      var emailVal = emailInput ? emailInput.value.trim() : '';
      if (!emailVal || !isValidEmail(emailVal)) {
        setError(emailInput, emailErr, true);
        valid = false;
      } else {
        setError(emailInput, emailErr, false);
      }

      if (!valid) return;

      /* Save lead so future downloads skip the form */
      saveLead({ name: nameVal, phone: phoneVal, email: emailVal });

      /* Disable submit & show processing state */
      submitBtn.disabled = true;
      submitBtn.textContent = 'Processing…';

      var pdfUrl = currentPdfUrl;
      var lang   = currentLang;

      /* Restore hidden fields (cleared by form.reset()) so they are included
         in the Shopify contact form submission below. */
      urlValInput.value  = pdfUrl;
      langValInput.value = lang;

      /* Trigger download immediately while still inside the user gesture (submit event).
         Mobile browsers block downloads initiated from async callbacks (fetch.then),
         so this must run synchronously before any await/fetch. */
      triggerDownload(pdfUrl, lang);
      showToast('Your PDF is downloading…');
      showSuccess();

      /* Submit lead to Shopify contact endpoint in the background */
      var formData = new URLSearchParams(new FormData(form));

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString()
      }).catch(function () {});
    });

    function showSuccess() {
      formWrap.hidden   = true;
      successDiv.hidden = false;
    }

    /* ── Silent re-submission for repeat downloads in a different language ── */
    function submitLeadSilently(saved, lang, pdfUrl) {
      var body = new URLSearchParams();
      body.append('form_type', 'contact');
      body.append('utf8', '✓');
      body.append('contact[name]',              saved.name  || '');
      body.append('contact[email]',             saved.email || '');
      body.append('contact[Phone Number]',      saved.phone || '');
      body.append('contact[Selected Language]', lang);
      body.append('contact[PDF URL]',           pdfUrl);
      body.append('contact[Product Title]',     downloadBtn.getAttribute('data-product-title') || '');
      body.append('contact[Product Type]',      downloadBtn.getAttribute('data-product-type')  || '');

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).catch(function () {});
    }
  }

  /* ── Auto-discover all brochure sections on the page ── */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="pdf-brochure-"]').forEach(function (el) {
      var pid = el.id.replace('pdf-brochure-', '');
      initBrochure(pid);
    });
  });

})();
